import "../Styles/Component/Carousel.css"
import hero1 from "../assets/images/hero 1.png"
import hero2 from "../assets/images/hero2.png"
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/autoplay';
import { useNavigate } from "react-router-dom";

const Carousel = () => {
  const navigate = useNavigate()

    return<>
        <section className="carousel">
        <Swiper navigation={true} modules={[Navigation, Autoplay]} className="mySwiper"
        autoplay={{delay: 3000, disableOnInteraction: false, pauseOnMouseEnter: true}}
        >
        <SwiperSlide>
          <div className="slider1">
            <h1>The easiest and fastest way to Invest in Agriculture</h1>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Illo, consequatur harum inventore expedita ipsum similique! Dolorem possimus dicta similique minima.</p>
            <button onClick={() => navigate("/product")}>Get Started</button>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="slider22">
          <div className="slider2Inner">
            <h1>Fresh and Simply Delicious</h1>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Illo, consequatur harum inventore expedita ipsum similique! Dolorem possimus dicta similique minima. Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium, omnis.
            </p>
            {/* <button onClick={() => navigate("/product")}>Get Started</button> */}
          </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="slider3">
          <div className="slider3Inner">
            <h1>Farm Fresh Produce right to your door</h1>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Illo, consequatur harum inventore expedita ipsum similique! Dolorem possimus dicta similique minima. 
            </p>
            {/* <button onClick={() => navigate("/product")}>Get Started</button> */}
          </div>
          </div>
        </SwiperSlide>
      </Swiper>
        </section>
    </>

}

export default Carousel;